module.exports = __webpack_public_path__ + "img/ico_sucesso.4f2c26ad.png";